import { Mark } from "@tiptap/core";

const ContentLink = Mark.create({
    name: "contentLink", // 👈 MUST MATCH
    inclusive: false,

    addAttributes() {
        return {
            href: {
                default: null,
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-content-link]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "span",
            {
                ...HTMLAttributes,
                "data-content-link": "",
                class: "text-green6 fw-bold",
                style: "color: blue; text-decoration: underline; cursor: pointer;",
            },
            0,
        ];
    },

    addCommands() {
        return {
            setContentLink:
                (attrs) =>
                    ({ commands }) => {
                        return commands.setMark(this.name, attrs);
                    },

            unsetContentLink:
                () =>
                    ({ commands }) => {
                        return commands.unsetMark(this.name);
                    },
        };
    },
});

export default ContentLink;